// Generated by protoc-gen-vendasta-ts — DO NOT EDIT
/* eslint-disable */
import { defer } from 'rxjs';
import { map } from 'rxjs/operators';
import { getMediaConstraintsRequestToJson, getMediaConstraintsResponseFromJson } from './codec';
import { fetchRpc } from '@vendasta/protos/fetch-transport';
import { getGlobalTransport } from '@vendasta/protos/transport';
export async function getMediaConstraints(request) {
    const raw = await fetchRpc('conversation.v1.ChannelIntegrationService/GetMediaConstraints', getMediaConstraintsRequestToJson(request));
    return getMediaConstraintsResponseFromJson(raw);
}
export function getMediaConstraints$(request, options) {
    return defer(() => getMediaConstraintsWithTransport$(getGlobalTransport(), request, options));
}
export function getMediaConstraintsWithTransport$(transport, request, options) {
    return transport
        .post('conversation.v1.ChannelIntegrationService/GetMediaConstraints', getMediaConstraintsRequestToJson(request), options)
        .pipe(map(resp => getMediaConstraintsResponseFromJson(resp)));
}
